// @flow
import { actions as ticketList } from '../../../duck';

export const { clearSelected, refresh } = ticketList;

export default {
    clearSelected,
    refresh,
};
